import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AgpSharedAddressModule,
  AgpSharedModule
} from '@liberty-financial/agp-shared';
import { LdsComponentsModule } from '@liberty-financial/ng-components';
import {
  LDS_CONFIG,
  LdsConfig,
  LdsCoreModule
} from '@liberty-financial/ng-core';
import { ModalModule } from 'ngx-bootstrap/modal';

import { Claims } from '@core/authentication/claims';
import { aggregator } from '@env/aggregator/aggregator';

import { AppbarModule } from './components/appbar/appbar.module';
import { LayoutModule } from './components/base/layout/layout.component.module';
import { SparkCountryModule } from './components/country/country.module';
import { AuditModule } from './components/audit/audit.module';
import { DialogComponent } from './components/dialog/dialog.component';
import { CreditAdviceFeeModule } from './components/credit-advice-fee/credit-advice-fee.module';
import { TagInputModule } from './components/tag-input/tag-input.module';
import {
  InlineContent,
  InlineItemComponent,
  InlineSummary
} from './components/inline-item/inline-item.component';
import { DynamicInlineMessageModule } from './components/inline-message/inline-message.module';
import { InlineMessageButtonModule } from './components/inline-message-button/inline-message-button.module';
import { LoadModule } from './components/load/load.module';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { SummaryCardModule } from './components/summary/summary-card/summary-card.module';
import { SummaryPanelModule } from './components/summary/summary-panel/summary-panel.module';
import { UserDropdownModule } from './components/user-dropdown/user-dropdown.module';
import { FilterableMultiSelectDropdownModule } from './components/filterable-multi-select-dropdown/filterable-multi-select-dropdown.module';
import { PipesModule } from './pipes/pipes.module';
import { SparkPlusDirectiveModule } from './directives/directives.module';
import { AppStatusService } from './services/service-workers';
import { HeapAnalyticsService } from './services/heap-analytics.service';

export function LdsConfigFactory(): LdsConfig {
  return {
    countryCode: aggregator.settings.claims.defaults.country,
    locale: Claims.Country.toLocale(
      aggregator.settings.claims.defaults.country
    ),
    currencyCode: Claims.Country.toCurrencyCode(
      aggregator.settings.claims.defaults.country
    )
  };
}

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    LoadModule,
    DynamicInlineMessageModule,
    InlineMessageButtonModule,
    AppbarModule,
    LayoutModule,
    SummaryPanelModule,
    SummaryCardModule,
    UserDropdownModule,
    FilterableMultiSelectDropdownModule,
    LdsCoreModule,
    LdsComponentsModule,
    AgpSharedModule,
    AgpSharedAddressModule,
    SparkCountryModule,
    CreditAdviceFeeModule,
    AuditModule,
    TagInputModule,
    SparkPlusDirectiveModule
  ],
  exports: [
    InlineItemComponent,
    InlineSummary,
    InlineContent,
    DynamicInlineMessageModule,
    InlineMessageButtonModule,
    AppbarModule,
    LayoutModule,
    SummaryPanelModule,
    SummaryCardModule,
    UserDropdownModule,
    FilterableMultiSelectDropdownModule,
    PipesModule,
    LdsCoreModule,
    LdsComponentsModule,
    AgpSharedModule,
    AgpSharedAddressModule,
    SparkCountryModule,
    AuditModule,
    CreditAdviceFeeModule,
    TagInputModule,
    LoadingOverlayComponent,
    SparkPlusDirectiveModule
  ],
  declarations: [
    DialogComponent,
    InlineItemComponent,
    InlineSummary,
    InlineContent,
    LoadingOverlayComponent
  ],
  providers: [
    AppStatusService,
    HeapAnalyticsService,
    {
      provide: LDS_CONFIG,
      useFactory: LdsConfigFactory
    }
  ]
})
export class SharedModule {}
